export const SET_LINKS = 'SET_LINKS'
export const SET_LINKS_LOADING = 'SET_LINKS_LOADING'
export const actions = {
  setLinks: payload => ({ type: SET_LINKS, payload }),
  loadingLinks: payload => ({ type: SET_LINKS_LOADING, payload }),
}
